import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import { IRootState } from '../../../typings';
import {
  deleteBroadcastAffiliation,
  fetchBroadcastAffiliations,
  updateBroadcastAffiliation,
} from '../actions';

type IOwnProps = RouteComponentProps;

const mapDispatchToProps = {
  fetchBroadcastAffiliations,
  updateBroadcastAffiliation,
  deleteBroadcastAffiliation,
};

const mapStateToProps = (state: IRootState) => ({
  broadcastAffiliations: state.broadcastAffiliations.list,
  fetching: state.broadcastAffiliations.fetching,
});

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  IOwnProps;

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);

export const connector = compose<IComponentProps>(reduxConnector, injectIntl);
